export const AWS_REGIONS_OPTIONS = [
    { label: 'US East (N. Virginia)', value: 'us-east-1' },
    { label: 'US East (Ohio)', value: 'us-east-2' },
    { label: 'US West (N. California)', value: 'us-west-1' },
    { label: 'US West (Oregon)', value: 'us-west-2' },
    { label: 'South America (São Paulo)', value: 'sa-east-1' }
];
export const AWS_REGIONS = AWS_REGIONS_OPTIONS.map(option => option.value);
